module.exports = __webpack_public_path__ + "static/media/twitter.4f1ec883.svg";